'use client';
import {styled} from '@mui/material/styles';
import type {ComponentPropsWithoutRef} from 'react';

const VIDEO_PRELOAD = 'metadata';

const Video = styled('video')({
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  pointerEvents: 'none',
});

export interface VideoFirstFrameProps
  extends Omit<ComponentPropsWithoutRef<'video'>, 'src' | 'poster' | 'controls' | 'muted' | 'playsInline' | 'preload'> {
  src: string;
}

export function VideoFirstFrame({src, ...rest}: VideoFirstFrameProps) {
  return <Video src={`${src}#t=0.001`} preload={VIDEO_PRELOAD} muted playsInline aria-hidden {...rest} />;
}

VideoFirstFrame.displayName = 'VideoFirstFrame';
